import {
    TOGGLE_SELECTED, SET_READY, SHOW_ERROR, RESET_ERROR
} from 'constants/actionTypes/paypal';

const initialState = {
    isReady: false,
    isSelected: false,
    error: null
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case TOGGLE_SELECTED:
            return Object.assign({}, state, {
                isSelected: action.isSelected
            });
        case SET_READY:
            return Object.assign({}, state, {
                isReady: action.isReady
            });
        case SHOW_ERROR:
            return Object.assign({}, state, {
                error: action.error,
                isSelected: false
            });
        case RESET_ERROR:
            return Object.assign({}, state, {
                error: null
            });
        default:
            return state;
    }
};

export default reducer;
